<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Consulta Export de Ficha de EPI
      </p>
    </div>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm col-md-2">
        Linhas por Página:
        <q-input v-model="filtros.perPage" dense outlined type="number" />
      </div>
      <div class="q-ml-sm col-md-2">
        Agrupador:
        <q-select
          v-model="filtros.agrupador"
          :options="listaAgrupador"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Status:
        <q-select
          v-model="filtros.status"
          :options="listaStatus"
          dense
          outlined
        />
      </div>

      <div class="q-ml-sm col-md-2">
        Criado em:
        <q-input
          v-model="filtros.criadoEmInicial"
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.criadoEmInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="q-ml-sm col-md-2">
        Finalizado em:
        <q-input
          v-model="filtros.criadoEmFinal"
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.criadoEmFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>

    <div>
      <q-table
        flat
        class="my-sticky-dynamic"
        :rows="rows"
        :loading="disable"
        dense
        :title="'Todos os Exports:' + ' ' + logsQuantidade"
        :columns="columns"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="name"
        track-by="id"
      >
        <template v-slot:top-right> </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body-cell-arquivo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.arquivo }}
          </q-td>
        </template>
        <template v-slot:body-cell-filtros="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div v-if="props.row.filtros != null">
              <div v-for="(valor, chave) in props.row.filtros" :key="chave">
                {{ chave }}:{{ valor }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-webhook="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.webhook }}
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="verLog">
      <q-card>
        <q-card-section> </q-card-section>

        <q-card-section class="q-pt-none">
          <vue-json-pretty :data="log" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "agrupador",
    label: "Agrupador",
    field: "agrupador",
    align: "left",
  },
  {
    name: "agrupadorId",
    label: "Agrupador ID",
    field: "agrupadorId",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "webhook",
    label: "WebHook",
    field: "webhook",
    align: "left",
  },
  {
    name: "filtros",
    label: "Filtros",
    field: "filtros",
    align: "left",
  },
  {
    name: "arquivo",
    label: "Arquivo",
    field: "arquivo",
    align: "left",
  },
  {
    name: "numeroFuncionarios",
    label: "Número Funcionários",
    field: "numeroFuncionarios",
    align: "left",
  },
  {
    name: "criadoEm",
    label: "Criado em",
    field: (row) => date.formatDate(row.criadoEm, "DD/MM/YYYY"),
    align: "left",
  },
  {
    name: "finalizadoEm",
    label: "Finalizado em",
    field: (row) => date.formatDate(row.finalizadoEm, "DD/MM/YYYY"),
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import { date } from "quasar";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  components: { VueJsonPretty },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);
    const filter = ref("");
    const verLog = ref(false);
    const log = ref(null);
    const logsQuantidade = ref(0);
    const filtros = ref({
      perPage: 15,
      agrupador: "",
      numeroFuncionarios: "",
      criadoEmInicial: "",
      criadoEmFinal: "",
      status: "",
    });
    const pagination = ref({
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch(
          "seguranca/getConsultaExportFicha",
          {
            page: page,
            perPage: rowsPerPage,
            id: filtros.value.id == "" ? undefined : filtros.value.id,
            agrupador:
              filtros.value.agrupador == ""
                ? undefined
                : filtros.value.agrupador,
            agrupadorId:
              filtros.value.agrupadorId == ""
                ? undefined
                : filtros.value.agrupadorId,
            status:
              filtros.value.status == "" ? undefined : filtros.value.status,
            webhook:
              filtros.value.webhook == "" ? undefined : filtros.value.webhook,
            filtros:
              filtros.value.filtros == "" ? undefined : filtros.value.filtros,
            arquivo:
              filtros.value.arquivo == "" ? undefined : filtros.value.arquivo,
            numeroFuncionarios:
              filtros.value.numeroFuncionarios == ""
                ? undefined
                : filtros.value.numeroFuncionarios,
            criadoEmInicial:
              filtros.value.criadoEmInicial == ""
                ? undefined
                : filtros.value.criadoEmInicial.split("/").reverse().join("-"),
            criadoEmFinal:
              filtros.value.criadoEmFinal == ""
                ? undefined
                : filtros.value.criadoEmFinal.split("/").reverse().join("-"),
          }
        );

        rows.value = response.data.resultado.dados;

        pagination.value.rowsPerPage = response.data.resultado.perage;
        pagination.value.rowsNumber = response.data.resultado.total;
        logsQuantidade.value = response.data.resultado.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const routeNotificacao = async () => {
      router.push({
        name: "seguranca-consultar-export-ficha-epi",
      });
    };

    watchDebounced(
      [
        () => filtros.value.perPage,
        () => filtros.value.id,
        () => filtros.value.agrupador,
        () => filtros.value.agrupadorId,
        () => filtros.value.status,
        () => filtros.value.webhook,
        () => filtros.value.filtros,
        () => filtros.value.arquivo,
        () => filtros.value.numeroFuncionarios,
        () => filtros.value.criadoEmInicial,
        () => filtros.value.criadoEmFinal,
      ],
      () => {
        if (
          filtros.value.criadoEmInicial != "" &&
          filtros.value.criadoEmInicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.criadoEmFinal != "" &&
          filtros.value.criadoEmFinal.length != 10
        ) {
          return;
        }
        getDados(pagination.value.page, +filtros.value.perPage);
      },
      { debounce: 400 }
    );

    watchDebounced(
      () => filter.value,
      () => {
        getDados();
      },
      { debounce: 400 }
    );

    return {
      rows,
      columns,
      getDados,
      myLocale: {
        // starting with Sunday
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      routeNotificacao,
      verLog,
      log,
      filtros,
      filter: ref(""),
      listaAgrupador: ["centroCusto", "funcionario", "unidade"],
      listaStatus: ["finalizado", "pendente", "processando"],
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}

tbody tr td {
  white-space: pre-wrap;
}

.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
  position: sticky;
  top: 0;
  z-index: 10;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}

tbody tr .coluna-btn {
  width: 120px;
}

.my-sticky-dynamic {
  max-height: 500px;
}

.container-tabela {
  margin-top: 10px;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
